import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';

function App() {
  return (
    <Router>
      <div className="text-center bg-gray-900 min-h-screen text-white">
        <nav className="sticky top-0 z-50 backdrop-blur-lg bg-gray-900/90 border-b border-white/10 container mx-auto px-4 sm:px-6 py-4 flex justify-between items-center shadow-lg">
          <h1 className="text-cyan-400 text-xl sm:text-2xl font-bold m-0">Fixet</h1>
          <ul className="flex m-0 p-0 list-none">
            <li className="ml-4 sm:ml-6"><Link to="/" className="text-white no-underline px-3 py-2 rounded transition-colors hover:bg-gray-700 text-sm sm:text-base">Dashboard</Link></li>
            <li className="ml-4 sm:ml-6"><Link to="/privacy-policy" className="text-white no-underline px-3 py-2 rounded transition-colors hover:bg-gray-700 text-sm sm:text-base">Privacy Policy</Link></li>
            <li className="ml-4 sm:ml-6"><Link to="/terms-conditions" className="text-white no-underline px-3 py-2 rounded transition-colors hover:bg-gray-700 text-sm sm:text-base">Terms & Conditions</Link></li>
          </ul>
        </nav>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
